import React, { useState, useRef, useEffect, useContext } from 'react';
import '../../../assests/css/admin/AdmincmsManagement/AdminEventcms.css';
import Adminmasterlayout from '../../../layouts/Adminmasterlayout/Adminmasterlayout';
import axios from 'axios';
import { AppContext } from '../../../context/Appcontext';

const AdminEvent = () => {
  const { baseUrl, baseUrlForFiles } = useContext(AppContext);

  const [showForm, setShowForm] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedTab, setSelectedTab] = useState('dashboard');
  const [eventIdForUpdate, setEventIdForUpdate] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [events, setEvents] = useState([]);
  const [activeFormTab, setActiveFormTab] = useState('hero');

  // ── Hero Fields ──
  const [heroTitle, setHeroTitle] = useState('');
  const [heroSubtitle, setHeroSubtitle] = useState('');
  const [heroDate, setHeroDate] = useState('');
  const [heroImage, setHeroImage] = useState('');
  const [heroImagePreview, setHeroImagePreview] = useState(null);
  const heroImageRef = useRef(null);

  // ── Card Fields ──
  const [cardTitle, setCardTitle] = useState('');
  const [cardDescription, setCardDescription] = useState('');
  const [cardVenue, setCardVenue] = useState('');
  const [cardImage, setCardImage] = useState('');
  const [cardImagePreview, setCardImagePreview] = useState(null);
  const cardImageRef = useRef(null);

  // ── Schedule Fields ──
  const [schedule, setSchedule] = useState([{ time: '', activity: '' }]);

  // ── Gallery Fields ──
  // Each item: { image: File | string (existing filename), caption: string, preview: string|null }
  const [gallery, setGallery] = useState([]);
  const galleryImageRef = useRef(null);

  const formTabs = ['hero', 'card', 'schedule', 'gallery'];

  // ── Add Event ──
  const addEvent = () => {
    const formData = new FormData();
    formData.append('hero_title', heroTitle);
    formData.append('hero_subtitle', heroSubtitle);
    formData.append('hero_date', heroDate);
    formData.append('card_title', cardTitle);
    formData.append('card_description', cardDescription);
    formData.append('card_venue', cardVenue);
    formData.append('schedule', JSON.stringify(schedule));

    // Gallery: send caption/order metadata as JSON, and the actual new files separately
    const galleryMeta = gallery.map((item) => ({
      caption: item.caption,
      image: item.image instanceof File ? null : item.image, // null means "new file, match by order"
    }));
    formData.append('gallery', JSON.stringify(galleryMeta));
    gallery.forEach((item) => {
      if (item.image instanceof File) {
      formData.append('gallery_images[]', item.image);
      }
    });

    if (heroImage instanceof File) formData.append('hero_image', heroImage);
    if (cardImage instanceof File) formData.append('card_image', cardImage);

    axios.post(`${baseUrl}/admin/events/addEvent`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then((response) => {
      console.log(response.data);
      viewAllEvents();
      resetForm();
      setShowForm(false);
    }).catch((error) => {
      console.log(error);
    });
  };

  // ── Update Event ──
  const updateEvent = () => {
    const formData = new FormData();
    formData.append('id', eventIdForUpdate);
    formData.append('hero_title', heroTitle);
    formData.append('hero_subtitle', heroSubtitle);
    formData.append('hero_date', heroDate);
    formData.append('card_title', cardTitle);
    formData.append('card_description', cardDescription);
    formData.append('card_venue', cardVenue);
    formData.append('schedule', JSON.stringify(schedule));

    const galleryMeta = gallery.map((item) => ({
      caption: item.caption,
      image: item.image instanceof File ? null : item.image,
    }));
    formData.append('gallery', JSON.stringify(galleryMeta));
    gallery.forEach((item) => {
      if (item.image instanceof File) {
       formData.append('gallery_images[]', item.image);
      }
    });

    if (heroImage instanceof File) formData.append('hero_image', heroImage);
    if (cardImage instanceof File) formData.append('card_image', cardImage);

    axios.post(`${baseUrl}/admin/events/updateEvent`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then((response) => {
      console.log(response.data);
      viewAllEvents();
      resetForm();
      setShowModal(false);
    }).catch((error) => {
      console.log(error);
    });
  };

  // ── View All Events ──
  const viewAllEvents = () => {
    axios.get(`${baseUrl}/admin/events/viewAllEvents`)
      .then((response) => {
        setEvents(response.data.events);
      }).catch((error) => {
        console.log(error);
      });
  };

  // ── Handle Submit ──
  const handleSubmit = () => {
    if (eventIdForUpdate === null) {
      addEvent();
    } else {
      updateEvent();
    }
  };

  // ── Reset Form ──
  const resetForm = () => {
    setHeroTitle(''); setHeroSubtitle(''); setHeroDate(''); setHeroImage(''); setHeroImagePreview(null);
    setCardTitle(''); setCardDescription(''); setCardVenue(''); setCardImage(''); setCardImagePreview(null);
    setSchedule([{ time: '', activity: '' }]);
    setGallery([]);
    setEventIdForUpdate(null);
    setActiveFormTab('hero');
  };

  // ── Open Edit Modal ──
  const handleOpenEditModal = (event) => {
    setEventIdForUpdate(event.id);
    setHeroTitle(event.hero_title || '');
    setHeroSubtitle(event.hero_subtitle || '');
    setHeroDate(event.hero_date || '');
    setHeroImage(event.hero_image || '');
    setCardTitle(event.card_title || '');
    setCardDescription(event.card_description || '');
    setCardVenue(event.card_venue || '');
    setCardImage(event.card_image || '');
    let parsedSchedule = event.schedule;
if (typeof parsedSchedule === 'string') {
  try {
    parsedSchedule = JSON.parse(parsedSchedule);
  } catch (e) {
    parsedSchedule = [];
  }
}
setSchedule(Array.isArray(parsedSchedule) && parsedSchedule.length ? parsedSchedule : [{ time: '', activity: '' }]);
    setGallery(
      event.gallery?.length
        ? event.gallery.map(g => ({ image: g.image || '', caption: g.caption || '', preview: null }))
        : []
    );
    setActiveFormTab('hero');
    setShowModal(true);
  };

  // ── Delete Event ──
  const deleteEvent = (idToDelete) => {
    const formData = new FormData();
    formData.append('id', idToDelete);

    axios.post(`${baseUrl}/admin/events/deleteEvent`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then((response) => {
      console.log(response.data);
      viewAllEvents();
    }).catch((error) => {
      console.log(error);
    });
  };

  useEffect(() => {
    viewAllEvents();
  }, []);

  // ── Image Handlers ──
  const handleHeroImageChange = (e) => {
    const file = e.target.files[0];
    if (file) { setHeroImage(file); setHeroImagePreview(URL.createObjectURL(file)); }
  };
  const handleCardImageChange = (e) => {
    const file = e.target.files[0];
    if (file) { setCardImage(file); setCardImagePreview(URL.createObjectURL(file)); }
  };

  // ── Schedule Handlers ──
  const handleScheduleChange = (index, field, value) => {
    const updated = [...schedule];
    updated[index][field] = value;
    setSchedule(updated);
  };
  const addScheduleRow = () => setSchedule([...schedule, { time: '', activity: '' }]);
  const removeScheduleRow = (index) => setSchedule(schedule.filter((_, i) => i !== index));

  // ── Gallery Handlers (multiple file upload) ──
  const handleGalleryImagesChange = (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    const newItems = files.map(file => ({
      image: file,
      caption: '',
      preview: URL.createObjectURL(file),
    }));
    setGallery(prev => [...prev, ...newItems]);
    e.target.value = null; // reset so selecting the same files again still fires onChange
  };
  const handleGalleryCaptionChange = (index, value) => {
    const updated = [...gallery];
    updated[index].caption = value;
    setGallery(updated);
  };
  const removeGalleryRow = (index) => setGallery(gallery.filter((_, i) => i !== index));

  // ── Search Filter ──
  const filteredEvents = events.filter(e => {
    const q = searchQuery.toLowerCase();
    return (e.hero_title || '').toLowerCase().includes(q) ||
      (e.card_venue || '').toLowerCase().includes(q) ||
      (e.card_title || '').toLowerCase().includes(q);
  });

  // ── Form UI ──
  const renderFormContent = () => (
    <div className="ae__form-body">

      <div className="ae__form-tabs">
        {formTabs.map(tab => (
          <button
            key={tab}
            className={`ae__form-tab ${activeFormTab === tab ? 'ae__form-tab--active' : ''}`}
            onClick={() => setActiveFormTab(tab)}
            type="button"
          >
            <span className="ae__tab-icon">
              {tab === 'hero' ? '🎯' : tab === 'card' ? '🎪' : tab === 'schedule' ? '📅' : '🖼️'}
            </span>
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </button>
        ))}
      </div>

      {activeFormTab === 'hero' && (
        <div className="ae__tab-content">
          <div className="ae__form-grid">
            <div className="ae__form-group ae__form-group--image">
              <label className="ae__form-label">Hero Background Image</label>
              <input type="file" accept="image/*" ref={heroImageRef} style={{ display: 'none' }} onChange={handleHeroImageChange} />
              <div className="ae__image-uploader" onClick={() => heroImageRef.current.click()}>
                {heroImagePreview ? (
                  <img src={heroImagePreview} alt="Preview" className="ae__image-preview" />
                ) : heroImage && !(heroImage instanceof File) ? (
                  <img src={`${baseUrlForFiles}/${heroImage}`} alt="Preview" className="ae__image-preview" />
                ) : (
                  <div className="ae__image-placeholder">
                    <span className="ae__image-icon">🖼️</span>
                    <span className="ae__image-hint">Click to upload</span>
                  </div>
                )}
              </div>
            </div>
            <div className="ae__form-fields">
              <div className="ae__form-group">
                <label className="ae__form-label">Hero Title</label>
                <input type="text" className="ae__form-input" placeholder="e.g. Annual Fest 2025"
                  value={heroTitle} onChange={e => setHeroTitle(e.target.value)} />
              </div>
              <div className="ae__form-group">
                <label className="ae__form-label">Hero Subtitle</label>
                <input type="text" className="ae__form-input" placeholder="e.g. Energy • Talent • Culture"
                  value={heroSubtitle} onChange={e => setHeroSubtitle(e.target.value)} />
              </div>
              <div className="ae__form-group">
                <label className="ae__form-label">Event Date</label>
                <input type="date" className="ae__form-input"
                  value={heroDate} onChange={e => setHeroDate(e.target.value)} />
              </div>
            </div>
          </div>
        </div>
      )}

      {activeFormTab === 'card' && (
        <div className="ae__tab-content">
          <div className="ae__form-grid">
            <div className="ae__form-group ae__form-group--image">
              <label className="ae__form-label">Card Image</label>
              <input type="file" accept="image/*" ref={cardImageRef} style={{ display: 'none' }} onChange={handleCardImageChange} />
              <div className="ae__image-uploader" onClick={() => cardImageRef.current.click()}>
                {cardImagePreview ? (
                  <img src={cardImagePreview} alt="Preview" className="ae__image-preview" />
                ) : cardImage && !(cardImage instanceof File) ? (
                  <img src={`${baseUrlForFiles}/${cardImage}`} alt="Preview" className="ae__image-preview" />
                ) : (
                  <div className="ae__image-placeholder">
                    <span className="ae__image-icon">🖼️</span>
                    <span className="ae__image-hint">Click to upload</span>
                  </div>
                )}
              </div>
            </div>
            <div className="ae__form-fields">
              <div className="ae__form-group">
                <label className="ae__form-label">Card Title</label>
                <input type="text" className="ae__form-input" placeholder="e.g. Sports Day"
                  value={cardTitle} onChange={e => setCardTitle(e.target.value)} />
              </div>
              <div className="ae__form-group">
                <label className="ae__form-label">Description</label>
                <textarea className="ae__form-input ae__form-textarea" placeholder="Event description..."
                  value={cardDescription} onChange={e => setCardDescription(e.target.value)} rows={3} />
              </div>
              <div className="ae__form-group">
                <label className="ae__form-label">Venue</label>
                <input type="text" className="ae__form-input" placeholder="e.g. Main Stadium, Lahore"
                  value={cardVenue} onChange={e => setCardVenue(e.target.value)} />
              </div>
            </div>
          </div>
        </div>
      )}

      {activeFormTab === 'schedule' && (
        <div className="ae__tab-content">
          <div className="ae__dynamic-list">
            {schedule.map((item, i) => (
              <div key={i} className="ae__dynamic-row">
                <span className="ae__row-number">{i + 1}</span>
                <input type="text" className="ae__form-input" placeholder="Time (e.g. 9:00 AM)"
                  value={item.time} onChange={e => handleScheduleChange(i, 'time', e.target.value)} />
                <input type="text" className="ae__form-input ae__input-wide" placeholder="Activity name"
                  value={item.activity} onChange={e => handleScheduleChange(i, 'activity', e.target.value)} />
                {schedule.length > 1 && (
                  <button className="ae__remove-btn" onClick={() => removeScheduleRow(i)} type="button">✕</button>
                )}
              </div>
            ))}
            <button className="ae__add-row-btn" onClick={addScheduleRow} type="button">+ Add Schedule Row</button>
          </div>
        </div>
      )}

      {activeFormTab === 'gallery' && (
        <div className="ae__tab-content">
          <input
            type="file"
            accept="image/*"
            multiple
            ref={galleryImageRef}
            style={{ display: 'none' }}
            onChange={handleGalleryImagesChange}
          />

          <div
            className="ae__image-uploader"
            onClick={() => galleryImageRef.current.click()}
            style={{ marginBottom: '16px' }}
          >
            <div className="ae__image-placeholder">
              <span className="ae__image-icon">🖼️</span>
              <span className="ae__image-hint">Click to upload one or multiple images</span>
            </div>
          </div>

          <div className="ae__dynamic-list">
            {gallery.length === 0 && (
              <p className="ae__image-hint">No images added yet.</p>
            )}
            {gallery.map((item, i) => {
              const previewSrc = item.preview
                ? item.preview
                : item.image && !(item.image instanceof File)
                  ? `${baseUrlForFiles}/${item.image}`
                  : null;
              return (
                <div key={i} className="ae__dynamic-row">
                  <span className="ae__row-number">{i + 1}</span>
                  {previewSrc ? (
                    <img
                      src={previewSrc}
                      alt={`Gallery ${i + 1}`}
                      style={{ width: '56px', height: '56px', objectFit: 'cover', borderRadius: '8px', flexShrink: 0 }}
                    />
                  ) : (
                    <div className="ae__image-placeholder" style={{ width: '56px', height: '56px', flexShrink: 0 }}>
                      <span className="ae__image-icon">🖼️</span>
                    </div>
                  )}
                  <input
                    type="text"
                    className="ae__form-input ae__input-wide"
                    placeholder="Caption"
                    value={item.caption}
                    onChange={e => handleGalleryCaptionChange(i, e.target.value)}
                  />
                  <button className="ae__remove-btn" onClick={() => removeGalleryRow(i)} type="button">✕</button>
                </div>
              );
            })}
          </div>
        </div>
      )}

      <div className="ae__form-footer">
        <button className="ae__btn-cancel" onClick={() => { resetForm(); setShowForm(false); setShowModal(false); }} type="button">
          Cancel
        </button>
        <button className="ae__btn-submit" onClick={handleSubmit} type="button">
          {eventIdForUpdate ? '💾 Update Event' : '🚀 Publish Event'}
        </button>
      </div>
    </div>
  );

  return (

    <div className="ae">
      <div className="ae__container">

        <header className="ae__header">
          <div className="ae__header-left">
            <h1 className="ae__header-title">Event Management</h1>
            <p className="ae__header-sub">Create and manage your event page content</p>
          </div>
          <button className="ae__btn-new" onClick={() => { setShowForm(v => !v); resetForm(); }}>
            <span className="ae__btn-new-icon">{showForm ? '✕' : '+'}</span>
            {showForm ? 'Cancel' : 'New Event'}
          </button>
        </header>



        {showForm && (
          <section className="ae__form-section">
            <h2 className="ae__section-title">Add New Event</h2>
            {renderFormContent()}
          </section>
        )}

        <div className="ae__search-wrap">
          <span className="ae__search-icon">
            <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
              <circle cx="8.5" cy="8.5" r="5.5" stroke="#9D9694" strokeWidth="2" />
              <path d="M12.5 12.5L16.5 16.5" stroke="#9D9694" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </span>
          <input type="text" className="ae__search-input" placeholder="Search events by title, venue..."
            value={searchQuery} onChange={e => setSearchQuery(e.target.value)} />
          {searchQuery && <button className="ae__search-clear" onClick={() => setSearchQuery('')}>✕</button>}
        </div>

        <section className="ae__table-section">
          <div className="ae__table-header">
            <h2 className="ae__section-title">
              {searchQuery ? `Results (${filteredEvents.length})` : 'All Events'}
            </h2>
            <span className="ae__table-count">{filteredEvents.length} events</span>
          </div>

          <div className="ae__table-wrap">
            {filteredEvents.length === 0 ? (
              <div className="ae__empty">
                <div className="ae__empty-icon">📭</div>
                <h3>No events found</h3>
                <p>Try a different search or create a new event</p>
              </div>
            ) : (
              <table className="ae__table">
                <thead className="ae__table-head">
                  <tr>
                    <th className="ae__th ae__th--img">Image</th>
                    <th className="ae__th">Hero Title</th>
                    <th className="ae__th ae__th--hide-sm">Card Title</th>
                    <th className="ae__th ae__th--hide-md">Venue</th>
                    <th className="ae__th ae__th--hide-md">Date</th>
                    <th className="ae__th ae__th--hide-sm">Schedule</th>
                    <th className="ae__th ae__th--hide-sm">Gallery</th>
                    <th className="ae__th ae__th--center">Actions</th>
                  </tr>
                </thead>
                <tbody className="ae__table-body">
                  {filteredEvents.map(event => (
                    <tr key={event.id} className="ae__tr">
                      <td className="ae__td ae__td--img">
                        <img
                          src={`${baseUrlForFiles}/${event.hero_image}`}
                          alt={event.hero_title}
                          className="ae__row-img"
                        />
                      </td>
                      <td className="ae__td ae__td--title">
                        <span className="ae__post-title">{event.hero_title}</span>
                        <span className="ae__post-sub">{event.hero_subtitle}</span>
                      </td>
                      <td className="ae__td ae__td--hide-sm">
                        <span className="ae__post-desc">{event.card_title}</span>
                      </td>
                      <td className="ae__td ae__td--hide-md">
                        <span className="ae__venue-badge">📍 {event.card_venue || '—'}</span>
                      </td>
                      <td className="ae__td ae__td--hide-md">
                        <span className="ae__date-text">{event.hero_date || '—'}</span>
                      </td>
                      <td className="ae__td ae__td--hide-sm ae__td--center">
                        <span className="ae__count-badge ae__count-badge--blue">
                          {event.schedule?.length || 0} items
                        </span>
                      </td>
                      <td className="ae__td ae__td--hide-sm ae__td--center">
                        <span className="ae__count-badge ae__count-badge--purple">
                          {event.gallery?.length || 0} photos
                        </span>
                      </td>
                      <td className="ae__td ae__td--actions">
                        <div className="ae__action-group">
                          <button className="ae__action-btn ae__action-btn--edit" title="Edit" onClick={() => handleOpenEditModal(event)}>
                            <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
                              <path d="M11.3 2.3L13.7 4.7L5 13.4L2 14L2.6 11L11.3 2.3Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </button>
                          <button className="ae__action-btn ae__action-btn--delete" title="Delete" onClick={() => deleteEvent(event.id)}>
                            <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
                              <path d="M3 4H13M5 4V3C5 2.4 5.4 2 6 2H10C10.6 2 11 2.4 11 3V4M6 7V11M10 7V11M4 4L5 13C5 13.6 5.4 14 6 14H10C10.6 14 11 13.6 11 13L12 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </section>
      </div>

      {showModal && (
        <div className="ae__modal-overlay" onClick={() => { setShowModal(false); resetForm(); }}>
          <div className="ae__modal" onClick={e => e.stopPropagation()}>
            <div className="ae__modal-header">
              <h3>✏️ Edit Event</h3>
              <button className="ae__modal-close" onClick={() => { setShowModal(false); resetForm(); }}>✕</button>
            </div>
            <div className="ae__modal-body">
              {renderFormContent()}
            </div>
          </div>
        </div>
      )}

      {/* <nav className="ae__bottom-nav">
        {[
          { key: 'dashboard', label: 'Dashboard', icon: '⊞' },
          { key: 'events', label: 'Events', icon: '🎪' },
          { key: 'gallery', label: 'Gallery', icon: '🖼️' },
          { key: 'settings', label: 'Settings', icon: '⚙️' },
        ].map(({ key, label, icon }) => (
          <button key={key}
            className={`ae__nav-btn ${selectedTab === key ? 'ae__nav-btn--active' : ''}`}
            onClick={() => setSelectedTab(key)}>
            <span>{icon}</span>
            <span>{label}</span>
          </button>
        ))}
      </nav> */}
    </div>

  );
};

export default AdminEvent;